import * as $ from "jquery";
import { $body } from "../../Core/Body";
import DeliveryFields from "../Fields/DeliveryFields";

export default class AddressFormValidation
{
    readonly Selector: any;

    constructor()
    {
        this.validate = this.validate.bind(this);
        this.Selector = {
            FORM: '#addressForm'
        }
    }

    public validate()
    {
        $(this.Selector.FORM).validate({
            rules: DeliveryFields.getFields(this.Selector)
        });
    }

    public onLoad()
    {
        $body.on( "click", this.validate );
    }

    public onChange()
    {
        $( window ).on( "change", this.validate );
    }
}
import * as $ from "jquery";
import { $body } from "../../Core/Body";
import DeliveryFields from "../Fields/DeliveryFields";

export default class AddressFormValidation
{
    readonly Selector: any;

    constructor()
    {
        this.validate = this.validate.bind(this);
        this.Selector = {
            FORM: '#addressForm'
        }
    }

    public validate()
    {
        $(this.Selector.FORM).validate({
            rules: DeliveryFields.getFields(this.Selector)
        });
    }

    public onLoad()
    {
        $body.on( "click", this.validate );
    }

    public onChange()
    {
        $( window ).on( "change", this.validate );
    }
}
